import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../../routes';
import { TableRowSelect } from './tr-select';
import { TableRowInput } from './tr-input';

export default class TableAutorizador extends Component {
     
    constructor(props) {
        super(props);
        this.state = { 
            baseUrl: document.getElementById('baseUrl').value,
        };
    }

    render() {

        const { baseUrl } = this.state;
        const { autorizador, onChangeInputTableAutorizador, onSaveParamsAutorizador, onChange, autorizadores } = this.props;
        //const options = versiones.map((item, index) => <option key={index} value={item}>{item}</option>);
        //const options2 = regimenFiscales.map((item, index) => <option key={index} value={item.Regimen_Clave}>{item.Regimen_Clave} - {item.Regimen_Descripcion}</option>);
        const optionsAutorizador = autorizadores.map((item, index) => <option key={index} value={item.Id}>{item.Nombre}</option>);
        return(
            <div className="table-responsive">
                <table className="table table-sm">
                    <tbody>
                       

                        <TableRowSelect title="Autorizador"
                            name="Autorizador"
                            options={optionsAutorizador}
                            value={autorizador.Autorizador_Id}
                            onChange={onChange}
                        />
                        <TableRowInput   title="Usuario"
                                            type="text"
                                            name="Autorizador_Usuario"
                                            value={autorizador.Autorizador_Usuario}
                                            onChange={onChangeInputTableAutorizador}
                         />
                        <TableRowInput   title="Llave"
                                            type="text"
                                            name="Autorizador_Llave"
                                            value={autorizador.Autorizador_Llave}
                                            onChange={onChangeInputTableAutorizador}
                         />
                        <TableRowInput   title="Clave"
                                            type="text"
                                            name="Autorizador_Clave"
                                            value={autorizador.Autorizador_Clave}
                                            onChange={onChangeInputTableAutorizador}
                         />
                        <TableRowInput   title="Código Interno"
                                            type="text"
                                            name="Autorizador_CodigoInterno"
                                            value={autorizador.Autorizador_CodigoInterno}
                                            onChange={onChangeInputTableAutorizador}
                         />
                        <TableRowInput   title="Url Timbrar"
                                            type="text"
                                            name="Autorizador_URL"
                                            value={autorizador.Autorizador_URL}
                                            onChange={onChangeInputTableAutorizador}
                         />
                        <TableRowInput   title="Url Consulta"
                                            type="text"
                                            name="Autorizador_URL_Consulta"
                                            value={autorizador.Autorizador_URL_Consulta}
                                            onChange={onChangeInputTableAutorizador}
                        />
                       
                        <tr>
                            <td colSpan="2">
                                <button type="button" className="btn btn-custom-theme float-right"><i className="far fa-save" onClick={onSaveParamsAutorizador}></i></button>
                                <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right">
                                    <i className="fas fa-angle-double-left"></i>
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./Public/src/js/component/parametro/children/tabla-autorizador.jsx